var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 109,
    viewBox: "0 0 85 109",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.102 109h62.796C80.002 109 85 103.818 85 97.485v-85.97C85 5.182 80.002 0 73.898 0H11.102C4.994 0 0 5.182 0 11.515v85.97C0 103.818 4.994 109 11.102 109",
    fill: "#9494ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 59.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M64 59.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0M26 59.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0M10 59.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M42 42.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M64 42.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0M26 42.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0M10 42.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M42 76.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M26 76.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0M10 76.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M42 93.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M26 93.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0M10 93.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M14.552 26h56.896C73.41 26 75 24.362 75 22.344V12.66C75 10.638 73.41 9 71.448 9H14.552C12.59 9 11 10.638 11 12.66v9.684C11 24.362 12.59 26 14.552 26M69.5 71c3.039 0 5.5 2.51 5.5 5.605v16.79C75 96.49 72.539 99 69.5 99c-3.035 0-5.5-2.51-5.5-5.605v-16.79C64 73.51 66.465 71 69.5 71",
    fill: "#E3C2F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.92fd104aa97c0393e804a25354295051.svg";
export { ForwardRef as ReactComponent };